import React, { Component } from 'react'
import { connect } from 'react-redux'
import Router from 'next/router'
import CatalogQuickCartForm from './catalog-quick-cart-form'
import { Drawer, Tooltip } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import { withTranslation } from 'react-i18next'
import { getCurrentOrder, setShowQuickCart } from '../../actions'

class CatalogQuickCart extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
      this.props.getCurrentOrder()
  }

  handleOnClose = () => {
    this.props.setShowQuickCart(false)
  }

  handleViewDetails = () => {
    this.handleOnClose()
    Router.push({ pathname: '/cart' })
  }

  render() {
    const { showQuickCart, isMobile, t } = this.props

    return (
      <Drawer
        className='cart-drawer'
        open={showQuickCart}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {t('Cart')}
            <Tooltip title={t('viewDetails')}>
              <EyeOutlined onClick={this.handleViewDetails} style={{ cursor: 'pointer' }} />
            </Tooltip>
          </div>
        }
        placement='right'
        closable={true}
        onClose={this.handleOnClose}
      >
        <CatalogQuickCartForm isMobile={isMobile} />
      </Drawer>
    )
  }
}

const mapStateToProps = ({ catalog }) => {
  const { showQuickCart } = catalog

  return { showQuickCart }
}

export default connect(mapStateToProps, { setShowQuickCart, getCurrentOrder })(withTranslation()(CatalogQuickCart))
